export function CandlestickChartIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Candlestick Chart"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.45751 4.71442C3.70862 4.71443 4.07813 4.87332 4.07831 5.14556V7.48876H5.41502V12.4963H4.07831V14.5071C4.07824 14.7793 3.70847 14.9997 3.45751 15C3.20632 15 2.86378 14.7795 2.86371 14.5071V12.4963H1.5V7.48876H2.86889L2.86785 7.48314V5.14556C2.86803 4.87341 3.2065 4.71457 3.45751 4.71442ZM2.86371 11.3465H4.07831V8.63846H2.86785L2.86371 11.3465Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86171 1C8.24616 0.99993 8.52282 1.22064 8.52299 1.49289V2.77845H9.68723V7.28519H8.52299V10.0303C8.52285 10.3025 8.19101 10.5512 7.94001 10.5514C7.68887 10.5514 7.33376 10.2936 7.33362 10.0214V7.28519H6.0486V2.77845H7.32948V1.49289C7.32965 1.22067 7.61062 1.00005 7.86171 1ZM7.33362 6.13549H8.52299V3.92815H7.33362V6.13549Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5383 4.91607C12.7895 4.91607 13.159 5.07497 13.1592 5.3472L13.1633 7.17404H14.5V11.18H13.8316H13.1633V13.773C13.1632 14.0452 12.7935 14.2656 12.5425 14.2659C12.2913 14.2659 11.9488 14.0453 11.9487 13.773V11.18H10.585V7.17404H11.9528V6.74904L11.9487 5.3472C11.9489 5.07505 12.2873 4.91621 12.5383 4.91607ZM11.9487 10.6124H13.1633V7.90435H11.9528L11.9487 10.6124Z"
        fill="currentColor"
      />
    </svg>
  );
}
